import React from 'react'
import Header from './header'
import { HasAppAccessPrivateLayout } from '@ztechapps/webui.page'

// OwnText Admin doesn't use complex permissions for MVP
const hasAppAccessPermission = 'admin.canAccess'

export default function PrivateLayout() {
  return <HasAppAccessPrivateLayout hasAppAccessPermission={hasAppAccessPermission} header={<Header />} />
}
